export default __webpack_public_path__ + "static/media/maildoso-disabled.eb8ae5c6.svg";